module.exports = __webpack_public_path__ + "img/ch66.1d2c613e.jpg";